import { UadListingStatus } from '@aloft/toolkit-shared';

export const getShouldApplyDateOfSale = (listingStatus: UadListingStatus): boolean =>
  listingStatus === 'SettledSale';
